import { ProductDoc, ProductStateCode } from '@gooduncles/gu-app-schema';
import { getProducts } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

type SortKey = 'fullName' | 'price';

const sortLogic = (a: ProductDoc, b: ProductDoc, sortKey: SortKey, orderBy: 'asc' | 'desc') => {
  if (sortKey === 'fullName') {
    return orderBy === 'asc' ? a.fullName.localeCompare(b.fullName) : b.fullName.localeCompare(a.fullName);
  }
  return orderBy === 'asc' ? a.price - b.price : b.price - a.price;
};

const getProrductsForTag = async (args: [string, string, ProductDoc['_id'][]]) => {
  const [, tag, unhiddenProducts] = args;
  const products = await getProducts([['tags', 'array-contains', tag]]);

  const filteredProducts = products.filter(
    (product) =>
      // 판매중인 상태인 상품만 가져온다.
      [ProductStateCode.STOCK, ProductStateCode.OUTOFSTOCK].includes(product.state) &&
      // hidden 상태인 상품은 제외한다.
      // 단, unhiddenProducts에 포함된 상품은 제외하지 않는다.
      (product.hidden !== true || unhiddenProducts?.includes(product.productId))
  );
  return filteredProducts;
};

/**
 * @param mainTag
 * @param limit 한 번에 가져올 상품 페이지의 개수(한 페이지 당 10개의 상품)
 * @returns
 */
const useProrductsForTag = (
  tag: string,
  unhiddenProducts: ProductDoc['_id'][],
  sortKey: SortKey = 'fullName',
  orderBy: 'asc' | 'desc' = 'asc'
) => {
  const {
    data,
    isLoading: productsForTagLoading,
    error: productsForTagError,
  } = useSWR(tag ? ['tag', tag, unhiddenProducts] : null, getProrductsForTag, {
    revalidateOnFocus: false,
    errorRetryCount: 2,
  });

  return {
    productsForTag: data?.sort((a, b) => sortLogic(a, b, sortKey, orderBy)) || [],
    productsForTagError,
    productsForTagLoading,
  };
};

export default useProrductsForTag;
